import React from "react"

import useIsScreenFocused from "@/hooks/useIsScreenFocused"

export function useAutoRefresh({
  callback,
  intervalSeconds,
}: {
  callback: () => void
  intervalSeconds: number
}) {
  const countdownValue = React.useRef(intervalSeconds)
  const isFocused = useIsScreenFocused()
  React.useEffect(() => {
    const timeout = setInterval(() => {
      if (isFocused) {
        countdownValue.current = countdownValue.current - 1
        if (countdownValue.current === 0) {
          callback()
          countdownValue.current = intervalSeconds
        }
      }
    }, 1000)

    return () => {
      clearTimeout(timeout)
    }
  }, [callback, isFocused, intervalSeconds])
}
